import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import "./TableList.css";

const toBool = (v) => v === true || v === 1 || v === '1' || v === 'true';

export default function AdminClubCoaches() {
    const { clubId } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem("adminToken");

    const [clubName, setClubName] = useState(""); // ✅ numele clubului
    const [coaches, setCoaches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [error, setError] = useState(null);
    const [search, setSearch] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [editingCoach, setEditingCoach] = useState(null);

    const API_BASE = "https://www.fro.ro/api/coaches";

    /* === Fetch nume club === */
    useEffect(() => {
        const fetchClubName = async () => {
            try {
                const res = await fetch(`https://www.fro.ro/api/admins/get-club.php?id=${clubId}`, {
                    headers: { Authorization: "Bearer " + token },
                });
                const data = await res.json();
                if (data.success) setClubName(data.club.name);
                else setClubName("(club necunoscut)");
            } catch (err) {
                setClubName("(club necunoscut)");
            }
        };
        fetchClubName();
    }, [clubId, token]);

    /* === Fetch lista === */
    const fetchCoaches = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/index.php?club_id=${clubId}&year=${selectedYear}`, {
                headers: { Authorization: "Bearer " + token },
            });
            const data = await res.json();
            if (data.success) setCoaches(data.data);
            else throw new Error(data.message);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchCoaches(); }, [clubId, selectedYear]);

    /* === Adaugă / Editează === */
    const handleSave = async (e) => {
        e.preventDefault();
        const endpoint = editingCoach?.id ? "edit.php" : "create.php";
        const payload = {
            id: editingCoach?.id || null,
            first_name: editingCoach.first_name.trim(),
            last_name: editingCoach.last_name.trim(),
            birth_year: Number(editingCoach.birth_year),
            license_number: editingCoach.license_number?.trim() || "",
            email: editingCoach.email?.trim() || "",
            phone: editingCoach.phone?.trim() || "",
            club_id: Number(clubId),
        };

        try {
            const res = await fetch(`${API_BASE}/${endpoint}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify(payload),
            });

            const data = await res.json();
            if (data.success) {
                alert(data.message);
                setShowForm(false);
                setEditingCoach(null);
                fetchCoaches();
            } else {
                alert("Eroare: " + data.message);
            }
        } catch (err) {
            alert("Eroare la conexiune: " + err.message);
        }
    };

    /* === Șterge === */
    const handleDelete = async (id) => {
        if (!window.confirm("Sigur vrei să ștergi acest antrenor?")) return;
        try {
            const res = await fetch(`${API_BASE}/delete.php?id=${id}`, {
                method: "DELETE",
                headers: { Authorization: "Bearer " + token },
            });
            const data = await res.json();
            alert(data.message);
            fetchCoaches();
        } catch (err) {
            alert("Eroare la conexiune: " + err.message);
        }
    };

    /* === Legitimați === */
    const handleLegitimare = async (coach) => {
        if (!window.confirm(`Legitimezi antrenorul ${coach.first_name} ${coach.last_name}?`)) return;
        try {
            const res = await fetch(`${API_BASE}/legitimeaza-coach.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify({
                    coach_id: coach.id,
                    club_id: coach.club_id,
                    year: selectedYear,
                }),
            });
            const data = await res.json();
            if (data.success) {
                alert(data.message);
                fetchCoaches();
            } else alert("Eroare: " + data.message);
        } catch (err) {
            alert("Eroare: " + err.message);
        }
    };

    const filtered = coaches.filter((c) =>
        (`${c.first_name} ${c.last_name}`.toLowerCase()).includes(search.toLowerCase())
    );

    if (loading) return <p>Se încarcă...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <div className="table-list-container">
            <div className="table-list-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    ⬅Înapoi
                </button>
                
                <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                    className="year-dropdown"
                >
                    {[new Date().getFullYear(), new Date().getFullYear() + 1].map((y) => (
                        <option key={y} value={y}>{y}</option>
                    ))}
                </select>
                <h2>
                    Antrenori – {clubName ? clubName : `Club #${clubId}`}
                </h2>

                <input
                    type="text"
                    className="search-bar"
                    placeholder="Caută antrenor..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="add-circle-btn"
                    onClick={() => {
                        setEditingCoach({
                            first_name: "",
                            last_name: "",
                            birth_year: "",
                            license_number: "",
                            email: "",
                            phone: "",
                        });
                        setShowForm(true);
                    }}
                >
                    <span className="plus-icon">+</span>
                </button>
            </div>

            <table className="table-list">
                <thead>
                    <tr>
                        <th>Nr. legitimație</th>
                        <th>Nume</th>
                        <th>An naștere</th>
                        <th>Email</th>
                        <th>Telefon</th>
                        <th>Activat</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {filtered.length === 0 ? (
                        <tr><td colSpan={7}>Niciun antrenor găsit.</td></tr>
                    ) : (
                        filtered.map((coach) => (
                            <tr key={coach.id}>
                                <td>{coach.license_number || "-"}</td>
                                <td>{coach.first_name} {coach.last_name}</td>
                                <td>{coach.birth_year}</td>
                                <td>{coach.email || "-"}</td>
                                <td>{coach.phone || "-"}</td>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={toBool(coach.is_legitimated)}
                                        disabled={toBool(coach.is_legitimated)}
                                        onChange={() => handleLegitimare(coach)}
                                    />
                                </td>
                              <td className="table-list-actions">
  <button className="action-btn edit" onClick={() => { setEditingCoach(coach); setShowForm(true); }}>
    <FontAwesomeIcon icon={faPen} />
  </button>
  <button className="action-btn delete" onClick={() => handleDelete(coach.id)}>
    <FontAwesomeIcon icon={faTrash} />
  </button>
</td>

                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* === FORM MODAL === */}
            {showForm && (
                <div className="modal-backdrop" onClick={() => setShowForm(false)}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                        <h3>{editingCoach?.id ? "Editează antrenor" : "Adaugă antrenor"}</h3>
                        <form className="modal-form" onSubmit={handleSave}>
                            <label>Prenume</label>
                            <input
                                type="text"
                                value={editingCoach.first_name}
                                onChange={(e) => setEditingCoach({ ...editingCoach, first_name: e.target.value })}
                                required
                            />
                            <label>Nume</label>
                            <input
                                type="text"
                                value={editingCoach.last_name}
                                onChange={(e) => setEditingCoach({ ...editingCoach, last_name: e.target.value })}
                                required
                            />
                            <label>An naștere</label>
                            <input
                                type="number"
                                value={editingCoach.birth_year}
                                onChange={(e) => setEditingCoach({ ...editingCoach, birth_year: e.target.value })}
                                required
                            />
                            <label>Nr. licență</label>
                            <input
                                type="text"
                                value={editingCoach.license_number}
                                onChange={(e) => setEditingCoach({ ...editingCoach, license_number: e.target.value })}
                            />
                            <label>Email</label>
                            <input
                                type="email"
                                value={editingCoach.email}
                                onChange={(e) => setEditingCoach({ ...editingCoach, email: e.target.value })}
                            />
                            <label>Telefon</label>
                            <input
                                type="text"
                                value={editingCoach.phone}
                                onChange={(e) => setEditingCoach({ ...editingCoach, phone: e.target.value })}
                            />

                            <div className="modal-actions">
                                <button type="submit" className="save-btn">Salvează</button>
                                <button type="button" className="cancel-btn" onClick={() => setShowForm(false)}>Anulează</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
